import { Navigate, Route } from 'react-router-dom';
import { AccountPage } from '@/features/auth/pages/AccountPage';
import { NotificationsCenter } from '@/features/auth/pages/NotificationsCenter';
import { OverviewPage } from './pages/OverviewPage';
import { ApplicationPage } from './pages/ApplicationPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { PaymentPage } from './pages/PaymentPage';
import { ExamPage } from './pages/ExamPage';
import { ResultPage } from './pages/ResultPage';
import { OfferPage } from './pages/OfferPage';

/** Returns <Route> children — mount inside a parent <Route>. */
export function applicantRoutes() {
  return (
    <>
      <Route index element={<Navigate to="overview" replace />} />
      <Route path="overview" element={<OverviewPage />} />
      <Route path="application" element={<ApplicationPage />} />
      <Route path="documents" element={<DocumentsPage />} />
      <Route path="payment" element={<PaymentPage />} />
      <Route path="exam" element={<ExamPage />} />
      <Route path="result" element={<ResultPage />} />
      <Route path="offer" element={<OfferPage />} />
      <Route path="notifications" element={<NotificationsCenter />} />
      <Route path="account" element={<AccountPage showPin={false} />} />
    </>
  );
}
